import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { brandPrimary, darkGrayFontColor, destructive, label } from '../../../web/styles/colors';

const { spacing, common, colors } = THEME;

export const styleSheet = StyleSheet.create({
	addButton: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		color: brandPrimary,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: spacing.xs,
		marginTop: spacing.xs,
		padding: 0,
	},
	deleteButton: {
		color: destructive,
	},
	editingForLabel: {
		color: darkGrayFontColor,
		fontSize: 13,
	},
	emptyState: {
		color: darkGrayFontColor,
		fontSize: 14,
		marginTop: spacing.sm,
		textAlign: 'center',
	},
	fieldLabel: {
		color: label,
		fontSize: 12,
		fontWeight: 600,
		marginBottom: 2,
		textTransform: 'uppercase',
	},
	fieldRow: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	formActions: {
		display: 'flex',
		gap: spacing.sm,
		marginTop: spacing.xs,
	},
	formModal: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		minWidth: 460,
		padding: spacing.md,
	},
	formSection: {
		backgroundColor: '#FAFAFA',
		border: '1px solid #E0E0E0',
		borderRadius: 6,
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		padding: spacing.sm,
	},
	formSectionEmpty: {
		color: darkGrayFontColor,
		fontSize: 13,
	},
	formSectionHeading: {
		color: label,
		fontSize: 13,
		fontWeight: 700,
		textTransform: 'uppercase',
		letterSpacing: '0.05em',
	},
	iconButton: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		color: darkGrayFontColor,
		cursor: 'pointer',
		display: 'flex',
		flexShrink: 0,
		padding: 4,
		':disabled': {
			cursor: 'not-allowed',
			opacity: 0.4,
		},
	},
	pagePanel: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		maxWidth: 720,
		padding: spacing.md,
		width: '100%',
	},
	permissionRow: {
		alignItems: 'center',
		backgroundColor: '#FAFAFA',
		border: '1px solid #E0E0E0',
		borderRadius: 6,
		display: 'flex',
		gap: spacing.sm,
		justifyContent: 'space-between',
		padding: spacing.sm,
	},
	permissionRowDetails: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 2,
	},
	permissionRowSubtitle: {
		color: darkGrayFontColor,
		fontSize: 12,
	},
	permissionRowTitle: {
		color: label,
		fontSize: 14,
		fontWeight: 600,
	},
	selectTrigger: {
		width: '100%',
	},
	specificUserLabel: {
		color: darkGrayFontColor,
		fontSize: 13,
		marginTop: 2,
	},
	senderSearchModal: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
		minWidth: 360,
		padding: spacing.md,
	},
	textInput: {
		border: '1px solid #CCCCCC',
		borderRadius: 4,
		color: label,
		fontSize: 16,
		outline: 'none',
		padding: spacing.sm,
		marginTop: 5,
		marginBottom: 5,
		width: '95%',
		':focus': {
			borderColor: brandPrimary,
		},
	},
	title: {
		color: label,
		fontSize: 16,
		fontWeight: 700,
	},
	addOwnerButton: {
		alignSelf: 'flex-start',
		background: 'none',
		border: 'none',
		color: brandPrimary,
		cursor: 'pointer',
		fontSize: 13,
		padding: 0,
	},
	ownerChip: {
		alignItems: 'center',
		backgroundColor: '#EEF2FF',
		borderRadius: 4,
		color: label,
		display: 'flex',
		fontSize: 13,
		gap: 4,
		padding: '2px 6px',
	},
	ownerChipRemove: {
		background: 'none',
		border: 'none',
		color: darkGrayFontColor,
		cursor: 'pointer',
		fontSize: 14,
		lineHeight: 1,
		padding: 0,
		':hover': {
			color: destructive,
		},
	},
	ownerList: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	privateContactsRow: {
		alignItems: 'flex-start',
		cursor: 'pointer',
		display: 'flex',
		gap: spacing.sm,
	},
	privateContactsText: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 2,
	},
	privateContactsLabel: {
		color: label,
		fontSize: 13,
		fontWeight: 600,
	},
	privateContactsHelper: {
		color: darkGrayFontColor,
		fontSize: 12,
		lineHeight: 1.4,
	},
	privateContactsHelperWarning: {
		backgroundColor: colors.warning.light,
		border: `1px solid ${colors.warning.main}`,
		borderRadius: common.borderRadius,
		color: colors.warning.contrastText,
		fontSize: 12,
		fontWeight: 500,
		lineHeight: 1.4,
		marginTop: 4,
		padding: spacing.xs,
	},
});
